export const getFeedbackLink = (qrHash: string) =>
    `qr.magictap.me/?hash=${qrHash}`;
